import axios from 'axios'

// const url='http://localhost:8000';
const url='https://e-commerce-website-backend-smul.onrender.com';

export const signupAuth=async(userData)=>{
    try{
        return await axios.post(`${url}/signup`,userData);
    }
    catch(e){
        console.log("couldn't signup", e);
    }
}

export const loginAuth=async(userData)=>{
    try{
        return await axios.post(`${url}/login`,userData);
    }
    catch(e){
        console.log("couldn't login", e);
    }
}